export default "__VITE_ASSET__CHMkIzOL__"